import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IEntityTask } from 'app/models/entity-task/entity-task';

@Injectable({providedIn: 'root'})
export class EntityTaskService {

    private api: string = environment.privateApi + 'EntityTask/';
    private http = inject(HttpClient);

    public getAllEntityTasks(entityType: string, includeAll: boolean): Observable<IEntityTask[]>{
        return this.http.get<IEntityTask[]>(this.api + 'GetAllEntityTasks/' + entityType + '/' + includeAll);
    }

    public getEntityTasks(entityId: number, entityType: string, includeAll: boolean): Observable<IEntityTask[]>{
        return this.http.get<IEntityTask[]>(this.api + 'GetEntityTasks/' + entityId + '/' + entityType + '/' + includeAll);
    }

    public updateEntityTask(entityTask: IEntityTask): Observable<boolean>{
        return this.http.post<boolean>(this.api + 'UpdateEntityTask', entityTask);
    }
}
